export async function getDocumentContent(): Promise<string> {
  return await Word.run(async (context) => {
    const body = context.document.body;
    body.load("text");
    await context.sync();
    return body.text;
  });
}

export async function insertText(text: string): Promise<void> {
  return await Word.run(async (context) => {
    let body = context.document.body;
    body.insertParagraph(text, Word.InsertLocation.end);
    await context.sync();
  });
}

export async function getDocumentAsFile(): Promise<File> {
  return new Promise((resolve, reject) => {
    Office.context.document.getFileAsync(Office.FileType.Compressed, { sliceSize: 65536 }, async (result) => {
      if (result.status === Office.AsyncResultStatus.Succeeded) {
        const file = result.value;
        const slices: Uint8Array[] = [];
        let slicesReceived = 0;

        const appendSlice = (slice: Office.Slice) => {
          const data = new Uint8Array(slice.data);
          slices.push(data);
          slicesReceived++;

          if (slicesReceived < file.sliceCount) {
            file.getSliceAsync(slicesReceived, (sliceResult) => {
              if (sliceResult.status === Office.AsyncResultStatus.Succeeded) {
                appendSlice(sliceResult.value);
              } else {
                reject(sliceResult.error);
              }
            });
          } else {
            file.closeAsync();
            const blob = new Blob(slices, {
              type: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
            });
            resolve(new File([blob], "document.docx", { type: blob.type }));
          }
        };

        file.getSliceAsync(0, (sliceResult) => {
          if (sliceResult.status === Office.AsyncResultStatus.Succeeded) {
            appendSlice(sliceResult.value);
          } else {
            reject(sliceResult.error);
          }
        });
      } else {
        reject(result.error);
      }
    });
  });
}

export async function getDocumentName(): Promise<string> {
  return await Word.run(async (context) => {
    const properties = context.document.properties;
    properties.load("title");
    await context.sync();
    return properties.title || "Untitled Document";
  });
}
